export class Produtotipo{


  public Id: number;
  public Descricao: string;
}